<template>
  <el-dialog width="500px" append-to-body title="创建团队" :visible.sync="visible" :before-close="handleClose">
    <el-form autoComplete="on" :model="form" v-loading="loading" :rules="formRules" element-loading-text="给我一点时间"
      label-position="right" ref="form" label-width="140px" label-suffix="：">
      <el-form-item label="团队名称" prop="name">
        <el-input type="text" style="width:250px" v-model="form.name" placeholder="请输入团队名称"> </el-input>
      </el-form-item>
      <el-form-item label="所在高校/单位" prop="company">
        <el-input type="text" style="width:250px" v-model="form.company" placeholder="请输入所在高校/单位">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="handleClose">取消</el-button> -->
      <el-button v-waves type="primary" @click.native.prevent="handleCheckTeam" :loading="loading">申请团队</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addTeam } from '@/api/user'
import waves from '@/directive/waves'; // 水波纹指令

export default {
  name: 'UserAddTeam',
  components: {},
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    hasTeam: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(value) {
      if (value) {

      }
    }
  },
  data() {
    return {
      loading: false,
      form: {
        name: '',
        company: '',
      },
      formRules: {
        name: [
          { required: true, message: '请输入团队名称', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入所在高校/单位', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    handleCheckTeam() {
      // 验证form表单
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.hasTeam) {
            this.$confirm('您已经在其他团队，如继续创建将会自动离开原团队?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
              this.handleAddTeam();
            });
          } else {
            this.handleAddTeam();
          }
        }
      })
    },
    // 新增团队
    handleAddTeam() {
      this.loading = true;
      const _form = JSON.parse(JSON.stringify(this.form))
      addTeam(_form).then((response) => {
        this.loading = false;
        // 关闭窗口
        this.handleClose();
        this.$emit('success', true);
        // 弹出操作提示
        this.$message({
          type: 'success',
          message: '申请团队成功，请等待管理员审核!'
        });
      }).catch(() => {
        this.loading = false;
      });
    },
    // 关闭窗口
    handleClose() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      // 更新visible参数
      this.$emit('update:visible', false);
    }
  }
};
</script>
<style lang="scss" scoped></style>